import { useContext, useEffect, useState } from "react";
import { getData } from "src/actions/getData";
import MiniInfoButton from "src/components/MiniInfoButton";
import PageHeader from "src/components/PageHeader";
import Table from "src/components/Table";
import { numberWithCommas } from "src/utils/thousandSeprator";
import { FiEye } from "react-icons/fi";
import { TbReload } from "react-icons/tb";
import { get } from "src/services/HttpClient";
import ModalHeader from "src/components/Modal/ModalHeader";
import ModalBody from "src/components/Modal/ModalBody";
import ModalFooter from "src/components/Modal/ModalFooter";
import Modal from "src/components/Modal/Modal";
import { LuPackageSearch } from "react-icons/lu";
import TwinButton from "src/components/TwinButton";
import { notify } from "src/services/Notification/Notification";
import InboundSingle from "../SellerManagement/components/InboundSingle";
import { put } from "src/services/HttpClient/HttpClient";
import { TbEyeSearch } from "react-icons/tb";



var moment = require("jalali-moment");

export default function Inbounds() {
    const [data, setData] = useState();
    const [loading, setLoading] = useState(false);
    const [modalOpen, setModalOpen] = useState(false);
    const [warehouseComment, setWarehouseComment] = useState("")
    const [viewInboundModalOpen, setViewInboundModalOpen] = useState(false);
    const [selectedInbound, setSelectedInbound] = useState(null)
    const [selectedItems, setSelectedItems] = useState(null);

    const updateInbound = async () => {
        setWarehouseComment("")
        let missedItem = selectedItems.find((item) => parseInt(item.delivaryQuantity) != parseInt(item.inboundQuantity))

        try {
            const payload = {
                warehouseComment,
                status: missedItem ? "partial" : "delivered",
                products: selectedItems.map(product => {
                    return {
                        ...product,
                        deliveredQuantity: product.delivaryQuantity,
                    }
                })
            };

            const result = await put(`/inbounds/seller/${selectedInbound.id}`, payload);

            if (result && result.success) {
                notify("محموله با موفقیت بروزرسانی شد", "success");
                getData(setData, "/inbounds")
                setModalOpen(false);
            } else {
                notify(result?.message || "خطا در ایجاد محموله", "error");
            }
        } catch (error) {
            notify("خطا در ارتباط با سرور", "error");
        }
    }


    useEffect(() => {
        // getInboundData();
        getData(setData, "/inbounds")
    }, []);


    useEffect(() => {
        if (selectedInbound && selectedInbound?.items && selectedInbound?.items.length) {            
            setSelectedItems(selectedInbound.items.map((row) => ({
                ...row,
                delivaryQuantity: row?.inboundQuantity,
            })));
        }
    }, [selectedInbound])

    const getInboundData = async () => {
        setLoading(true);
        try {
            const result = await get("/inbounds");
            if (result?.statusCode == 200) {
                setData(result.data);
            }
        } catch (error) {
            console.error("Error fetching inbound data:", error);
        } finally {
            setLoading(false);
        }
    };

    const getStatusColor = (status) => {
        switch (status) {
            case "pending":
                return "#facc15";
            case "delivered":
                return "#22c55e";
            case "partial":
                return "#d54a3b";
            case "cancelled":
                return "#ef4444";
            default:
                return "#6b7280";
        }
    };

    const getStatusText = (status) => {
        switch (status) {
            case "pending":
                return "در انتظار";
            case "delivered":
                return "تحویل شده";
            case "partial":
                return "کسری دارد";
            case "cancelled":
                return "لغو شده";
            default:
                return "نامشخص";
        }
    };

    const columns = [
        {
            id: "id",
            cell: (info) => info.getValue(),
            header: "شناسه",
        },
        {
            id: "status",
            cell: (info) => (
                <MiniInfoButton
                    text={getStatusText(info.getValue())}
                    backgroundColor={getStatusColor(info.getValue())}
                />
            ),
            header: "وضعیت",
        },
        {
            id: "seller",
            cell: (info) => info.getValue()?.firstName ? info.getValue()?.firstName : "" + " " + info.getValue()?.lastName ? info.getValue()?.lastName : "",
            header: "تامین کننده",
        },
        {
            id: "createdAt",
            cell: (info) => (
                <>
                    {info.getValue()
                        ? moment
                            .from(info.getValue())
                            .locale("fa")
                            .format("jYYYY/jMM/jDD HH:mm")
                        : "---"}
                </>
            ),
            header: "تاریخ ایجاد",
        },
        {
            id: "deliveredAt",
            cell: (info) => (
                <>
                    {info.getValue()
                        ? moment
                            .from(info.getValue())
                            .locale("fa")
                            .format("jYYYY/jMM/jDD HH:mm")
                        : "---"}
                </>
            ),
            header: "تاریخ تحویل",
        },
        {
            id: "warehouseComment",
            cell: (info) => info.getValue(),
            header: "توضیحات انباردار",
        },
        {
            id: "sellerComment",
            cell: (info) => info.getValue(),
            header: "توضیحات تامین کننده",
        },
        {
            id: "totalInboundQuantity",
            cell: (info) => {
                const products = info.row.original.items;
                if (!products) return 0;
                return products.reduce((sum, product) => sum + (product.inboundQuantity || 0), 0);
            },
            header: "مجموع تعداد محموله",
        },
        {
            id: "totalDeliveredQuantity",
            cell: (info) => {
                const products = info.row.original.items;
                if (!products) return 0;
                return products.reduce((sum, product) => sum + (product.deliveredQuantity || 0), 0);
            },
            header: "مجموع تعداد تحویل",
        },
        {
            id: "actions",
            cell: (info) => (
                <div className="flex gap-2">
                    {
                        info.row.original.deliveredAt
                            ?
                            <div
                                className="cursor-pointer hover:bg-gray-100 hover:text-gray-600 transition-all ease-in-out duration-300 bg-gray-50 dark:bg-gray-700 text-gray-400 p-2 rounded-lg"
                                onClick={() => {
                                    setSelectedItems(info.row.original.items);
                                    setSelectedInbound(info.row.original)
                                    setViewInboundModalOpen(true);
                                }}
                                title="مشاهده جزئیات"
                            >
                                <TbEyeSearch className="text-green-500" />
                            </div>
                            :
                            <div
                                className="cursor-pointer hover:bg-gray-100 hover:text-gray-600 transition-all ease-in-out duration-300 bg-gray-50 dark:bg-gray-700 text-gray-400 p-2 rounded-lg"
                                onClick={() => {
                                    setSelectedItems(info.row.original.items);
                                    setSelectedInbound(info.row.original)
                                    setModalOpen(true);
                                }}
                                title="ویرایش"
                            >
                                <LuPackageSearch className="text-blue-500" />
                            </div>
                    }
                </div>
            ),
            header: "عملیات",
            enableColumnFilter: false,
        },
    ];


    return (
        <>
            <PageHeader
                title="مدیریت محموله ها"
                btnTitle="بروزرسانی"
                handleClick={getInboundData}
                isBtnLoading={loading}
                btnIcon={<TbReload className="ml-1" size="22" />}
            />
            <Table
                columns={columns}
                data={data}
                CSVExportPermission="exportSellerInbound"
                tableName="seller-inbound"
            />
            <Modal isOpen={modalOpen} toggle={() => setModalOpen(false)} width={900}>
                <ModalHeader toggle={() => setModalOpen(false)}>
                    جزئیات محصولات ورودی
                </ModalHeader>
                <ModalBody>
                    <div className="p-4">
                        {selectedItems && selectedItems.length > 0 ? (
                            <div className="flex flex-col gap-2">
                                {selectedItems && selectedItems.map((item, idx) => (
                                    <InboundSingle
                                        index={idx}
                                        item={item}
                                        setInbound={setSelectedItems}
                                    />
                                ))}
                            </div>
                        ) : (
                            <div className="text-center py-8">محصولی وجود ندارد.</div>
                        )}
                        <div className="flex flex-col gap-4 mt-4">
                            <div className="flex flex-col gap-4">
                                {
                                    selectedInbound?.sellerComment
                                    &&
                                    <div className="flex flex-col gap-2">
                                        <span>توضیحات فروشنده</span>
                                        <p className="bg-gray-50 p-2 rounded-xl">
                                            {selectedInbound?.sellerComment}
                                        </p>
                                    </div>
                                }
                            </div>
                            <div className="flex flex-col gap-1">
                                <label htmlFor="">توضیحات انباردار</label>
                                <textarea className="rounded-xl p-2 bg-white border border-gray-200" name="" id="" value={warehouseComment} onChange={(e) => { setWarehouseComment(e.target.value) }}>اگر توضیحات خاصی مد نظرتان هست در این قسمت وارد کنید</textarea>
                            </div>
                        </div>
                    </div>
                </ModalBody>
                <ModalFooter>
                    <TwinButton
                        isCompact
                        rejectHandle={() => { setModalOpen(false); setWarehouseComment("") }}
                        acceptHandle={updateInbound}
                    />
                </ModalFooter>
            </Modal>



            <Modal isOpen={viewInboundModalOpen} toggle={() => setViewInboundModalOpen(false)} width={900}>
                <ModalHeader toggle={() => setViewInboundModalOpen(false)}>
                    <span>
                        جزییات مرسوله
                    </span>
                    <button
                        className="text-red-600 mx-2"
                        onClick={
                            () => {
                                setModalOpen(true);
                                setViewInboundModalOpen(false)
                            }
                        }
                    >
                        (ویرایش)
                    </button>
                </ModalHeader>
                <ModalBody>
                    <div className="p-4">
                        {selectedItems && selectedItems.length > 0 ? (
                            <div className="flex flex-col gap-[10px]">
                                {selectedItems.map((item, idx) => (
                                    <div key={idx} className={`${parseInt(item.deliveredQuantity ?? 0) < parseInt(item.inboundQuantity ?? 0) ? "!bg-red-100" : ""} flex flex-col md:flex-row items-center gap-4 border border-gray-200 rounded-lg p-2`}>
                                        <img
                                            className="w-[70px] h-[70px] object-cover rounded-lg border border-gray-100"
                                            src={`${process.env.REACT_APP_CDN_URL}/thumbnail/${item?.product?.id}/${item?.product?.featuredImage}`}
                                            alt={item.name}
                                        />
                                        <div className="flex-1 flex flex-col gap-1">
                                            <div className="flex flex-col flex-wrap gap-3">
                                                <span className="font-semibold text-sm">{item.name}</span>
                                                <div className="flex gap-4">
                                                    <span className="text-xs text-gray-500">SKU: {item.sku}</span>
                                                    <span className="text-xs text-gray-500">شماره سفارش: {item.orderId}</span>
                                                    <span className="text-xs text-gray-500">تاریخ سفارش: {moment
                                                        .from(item.createdAt)
                                                        .locale("fa")
                                                        .format("jYYYY/jMM/jDD HH:mm")}</span>
                                                </div>

                                            </div>
                                            <div className="flex flex-wrap gap-4 mt-2">
                                                <span className="text-xs text-gray-600">تعداد فروش: <b>{item.orderQuantity}</b></span>
                                                <span className="text-xs text-gray-600">تعداد تامین: <b>{item.inboundQuantity}</b></span>
                                                <span className="text-xs text-gray-600">تعداد تحویل: <b>{item.deliveredQuantity ?? 0}</b></span>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        ) : (
                            <div className="text-center py-8">محصولی وجود ندارد.</div>
                        )}
                        <div className="flex flex-col gap-4 mt-4">
                            {
                                selectedInbound?.sellerComment
                                &&
                                <div className="flex flex-col gap-2">
                                    <span>توضیحات فروشنده</span>
                                    <p className="bg-gray-50 p-2 rounded-xl">
                                        {selectedInbound?.sellerComment}
                                    </p>
                                </div>
                            }
                            {
                                selectedInbound?.warehouseComment
                                &&
                                <div className="flex flex-col gap-2">
                                    <span>توضیحات انباردار</span>
                                    <p className="bg-gray-50 p-2 rounded-xl">
                                        {selectedInbound?.warehouseComment}
                                    </p>
                                </div>
                            }
                        </div>
                    </div>
                </ModalBody>
            </Modal >
        </>
    );
}
